import stylex from '@stylexjs/stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { FC } from 'react';

const styles = stylex.create({
  icon: {
    borderRadius: '9999px',
    backgroundColor: colors.deepBackground,
    height: '28px',
    width: '28px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingRight: '2px ',
  },
  iconOnDeep: {
    backgroundColor: colors.primaryBackground,
  },
});

interface ChevronIconProps {
  color?: string;
  size?: number;
}

export const ChevronDownIcon: FC<ChevronIconProps> = ({ size = 16, color = colors.primaryText }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.35355 10.8536C8.15829 11.0488 7.84171 11.0488 7.64645 10.8536L2.64645 5.85355C2.45119 5.65829 2.45119 5.34171 2.64645 5.14645C2.84171 4.95119 3.15829 4.95119 3.35355 5.14645L8 9.79289L12.6464 5.14645C12.8417 4.95118 13.1583 4.95118 13.3536 5.14645C13.5488 5.34171 13.5488 5.65829 13.3536 5.85355L8.35355 10.8536Z"
        fill={color}
      />
    </svg>
  );
};

export const ChevronUpIcon: FC<ChevronIconProps> = ({ size = 16, color = colors.primaryText }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.35355 5.14645C8.15829 4.95119 7.84171 4.95119 7.64645 5.14645L2.64645 10.1464C2.45119 10.3417 2.45119 10.6583 2.64645 10.8536C2.84171 11.0488 3.15829 11.0488 3.35355 10.8536L8 6.20711L12.6464 10.8536C12.8417 11.0488 13.1583 11.0488 13.3536 10.8536C13.5488 10.6583 13.5488 10.3417 13.3536 10.1464L8.35355 5.14645Z"
        fill={color}
      />
    </svg>
  );
};

export const ChevronLeftIcon: FC<ChevronIconProps> = ({ color = colors.primaryText, size = 20 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.14645 8.35355C4.95118 8.15829 4.95118 7.84171 5.14645 7.64645L10.1464 2.64645C10.3417 2.45119 10.6583 2.45119 10.8536 2.64645C11.0488 2.84171 11.0488 3.15829 10.8536 3.35355L6.20711 8L10.8536 12.6464C11.0488 12.8417 11.0488 13.1583 10.8536 13.3536C10.6583 13.5488 10.3417 13.5488 10.1464 13.3536L5.14645 8.35355Z"
        fill={color}
        fillOpacity="0.7"
      />
    </svg>
  );
};

type ChevronLeftIconRoundedProps = {
  variant?: 'onPrimary' | 'onDeep';
};

export const ChevronLeftIconRounded = ({ variant = 'onPrimary' }: ChevronLeftIconRoundedProps) => {
  return (
    <div {...stylex.props(styles.icon, variant === 'onDeep' && styles.iconOnDeep)}>
      {' '}
      <ChevronLeftIcon />
    </div>
  );
};
